// extracted by mini-css-extract-plugin
module.exports = {"text":"MessageText_text__1dURR","time":"MessageText_time__3pCMV"};